import React from 'react'
import './index.less'

const ToolTip: React.FC = (props: any) => {
  const { text } = props
  return <div>{text || ''}</div>
}

export default ToolTip
